import Link from "next/link";
import React, { useState } from "react";
import { withTranslation } from "../../../i18n";
import LinksProvider from "../../../services/http/LinksProvider";
import ManageCoookiesModal from "../../cookies/ManageCookieModal/ManageCookieModal";
import SocialMediaLinks from "../SocialMediaLinks";
import css from "./FooterSitemap.module.scss";

const namespacesRequired = ["footer"];

const FooterSitemap = ({ t }) => {
  const [showManageCookieModal, setShowManageCookieModal] = useState(false);
  const xpollensImage = "/static/images/footer/xpollens.png";

  const listLinks = [
    {
      label: t("footer:links.list.advantages"),
      href: "/comment-ca-marche",
    },
    {
      label: t("footer:links.list.gifts"),
      href: "/gifts",
    },
    {
      label: t("footer:links.list.create"),
      href: "/inscription",
    },
    {
      label: t("footer:links.list.login"),
      href: "/connexion",
    },
    {
      label: t("footer:links.list.search"),
      href: "/rechercher-une-liste",
    },
    {
      label: t("footer:links.list.compare"),
      href:
        "/actualites/organisation/hvEzGddc-cadeaux-de-mariage-notre-comparatif-entre-urne-cagnotte-et-liste-de-mariage",
    },
  ];

  const prepLinks = [
    {
      label: t("footer:links.prep.providers"),
      href: "/carnet-adresses",
    },
    {
      label: t("footer:links.prep.blog"),
      href: "/actualites",
    },
    {
      label: t("footer:links.prep.qr"),
      href: "/actualites/organisation/AiqrzbSB-le-qr-code-de-votre-liste-de-mariage",
    },
    {
      label: t("footer:links.prep.checklist"),
      href:
        "/actualites/organisation/pse5FU2b-organisation-de-mariage-la-checklist-ultime-pour-ne-rien-oublier",
    },
    {
      label: t("footer:links.prep.honeymoon"),
      href: "/voyage-de-noces",
    },
    {
      label: t("footer:links.prep.formalities"),
      href:
        "/actualites/organisation/poaFjb2p-formalites-administratives-du-mariage-tout-ce-quil-faut-savoir",
    },
  ];

  const aboutLinks = [
    {
      label: t("footer:links.about.about"),
      href: "/actualites/jtKSo5m1",
    },
    {
      label: t("footer:links.about.cgu"),
      href: "/conditions-generales-utilisation",
    },
    {
      label: t("footer:links.about.privacy"),
      href: "/static/pdf/PVP_M1L_JUILLET2026.pdf",
      external: true,
    },
    {
      label: t("footer:links.about.cookies"),
      href: "#cookies",
      onClick: () => setShowManageCookieModal(true),
    },
    {
      label: t("footer:links.about.group"),
      href: "https://www.groupegalerieslafayette.fr",
      external: true,
    },
  ];

  const partnerLinks = [
    {
      label: t("footer:links.about.partner.gl"),
      href: "https://www.galerieslafayette.com",
    },
    {
      label: t("footer:links.about.partner.laredoute"),
      href: "https://www.laredoute.fr",
    },
    {
      label: t("footer:links.about.partner.bhv"),
      href: "https://www.bhv.fr",
    },
  ];

  const renderLink = (link) => {
    if (link.onClick) {
      return (
        <a
          href={link.href || "#"}
          className={css.linkButton}
          onClick={(event) => {
            if (!link.href || link.href.startsWith("#")) {
              event.preventDefault();
            }
            link.onClick(event);
          }}
        >
          {link.label}
        </a>
      );
    }

    if (link.external) {
      return (
        <a href={link.href} target="_blank" rel="noreferrer">
          {link.label}
        </a>
      );
    }

    return (
      <Link href={link.href}>
        <span>{link.label}</span>
      </Link>
    );
  };

  return (
    <div className={css.sitemap}>
      {showManageCookieModal && (
        <ManageCoookiesModal
          visible={showManageCookieModal}
          onHide={() => {
            setShowManageCookieModal(false);
          }}
          onSubmit={() => {
            setShowManageCookieModal(false);
          }}
        />
      )}
      <div className={css.columns}>
        <div className={css.column} data-section="list">
          <p className={css.columnTitle}>{t("footer:section.list")}</p>
          <ul className={css.linkList}>
            {listLinks.map((link) => (
              <li key={link.label}>{renderLink(link)}</li>
            ))}
          </ul>
        </div>
        <div className={css.column} data-section="prep">
          <p className={css.columnTitle}>{t("footer:section.prep")}</p>
          <ul className={css.linkList}>
            {prepLinks.map((link) => (
              <li key={link.label}>{renderLink(link)}</li>
            ))}
          </ul>
        </div>
        <div className={css.column} data-section="about">
          <p className={css.columnTitle}>{t("footer:section.about")}</p>
          <ul className={css.linkList}>
            {aboutLinks.map((link) => (
              <li key={link.label}>{renderLink(link)}</li>
            ))}
          </ul>
          <p className={css.partnerTitle}>{t("footer:links.about.partners")}</p>
          <ul className={css.partnerList}>
            {partnerLinks.map((link) => (
              <li key={link.label}>
                <a href={link.href} target="_blank" rel="noreferrer">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className={css.help} data-section="help">
          <p className={css.columnTitle}>{t("footer:section.help")}</p>
          <a
            href="https://milleetunelistes.zendesk.com/hc/fr"
            target="_blank"
            rel="noreferrer"
            className={css.helpLink}
          >
            {t("footer:help.center")}
          </a>
          <div className={css.helpContacts}>
            <p className={css.helpItem}>
              {t("footer:help.email_label")}{" "}
              <a
                href="mailto:contact@milleetunelistes.fr"
                className={css.helpStrong}
              >
                contact@milleetunelistes.fr
              </a>
            </p>
            <p className={css.helpItem}>
              {t("footer:help.phone_label")}{" "}
              <span className={css.helpStrong}>0805 53 1001</span>
            </p>
          </div>
          <p className={css.helpNote}>{t("footer:help.note")}</p>
        </div>
      </div>
      <div className={css.xpollens}>
        <img src={xpollensImage} alt="Xpollens" />
        <p>{t("footer:xpollens-note")}</p>
      </div>
      <div className={css.followMobile}>
        <p className={css.followTitle}>{t("footer:follow-us")}</p>
        <SocialMediaLinks />
      </div>
    </div>
  );
};

export default withTranslation(namespacesRequired)(FooterSitemap);
